import React from 'react';

const Lifestyle = () => {
    return (
        <section className='lifestyle mb-10'>
        <div className="container mx-auto">
        <h2 className="text-4xl">
        This is Lifestyle Page
        </h2>
        </div>
    </section>
    );
};

export default Lifestyle;